(() => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const selector = [
    '.rive-home__hero-copy',
    '.rive-home__hero-visual',
    '.rive-home__manifesto',
    '.rive-home__collection .rive-section-heading',
    '.rive-home__product-grid .rive-product-card',
    '.rive-home__atelier-image',
    '.rive-home__atelier-copy',
    '.rive-home__attention',
    '.rive-home__journal .rive-section-heading',
    '.rive-home__article',
    '.rive-home__newsletter',
    '.rive-collection__intro',
    '.rive-collection__wrap > .rive-product-grid .rive-product-card',
    '.rive-collection__help',
    '.rive-collection__sold-heading',
    '.rive-collection__sold-grid .rive-product-card',
    '.rive-blog__heading',
    '.rive-blog__card',
    '.rive-blog__closing',
    '.rive-article__heading',
    '.rive-article__visual',
    '.rive-article__layout',
    '.rive-article__footer',
    '.rive-inner-page__hero-copy',
    '.rive-inner-page__hero-visual',
    '.rive-inner-page__statement',
    '.rive-guide__measures',
    '.rive-guide__fit',
    '.rive-brand__materials',
    '.rive-brand__choice',
    '.rive-inner-page__closing',
    '.rive-generic-page__header',
    '.rive-generic-page__content',
    '.rive-page-visual__copy',
    '.rive-page-visual__inner > img',
    '.rive-product-detail__intro',
    '.rive-product-detail__related',
    'main[data-template^="product"] .product-information',
    'main[data-template^="cart"] .section',
    '.rive-footer__newsletter',
    '.rive-footer__bottom'
  ].join(',');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      target.classList.add('rive-reveal--visible');
      observer.unobserve(target);
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -20px 0px' });

  function prepare(root = document) {
    const elements = root.querySelectorAll(selector);
    elements.forEach((element) => {
      if (element.classList.contains('rive-reveal')) return;

      const parent = element.parentElement;
      if (parent?.matches('.rive-product-grid, .rive-home__articles, .rive-blog__grid')) {
        const position = Array.prototype.indexOf.call(parent.children, element) % 3;
        element.style.setProperty('--rive-reveal-delay', `${position * 65}ms`);
      }

      element.classList.add('rive-reveal');
      if (element.getBoundingClientRect().bottom < 0) {
        element.classList.add('rive-reveal--visible');
      } else {
        observer.observe(element);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  } else {
    prepare();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
